import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Informes/excelInformeProductividadExtraccionesVerraco`, method: 'POST', body: list, token: token})
}